'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _lodash = require('lodash');

var _lodash2 = _interopRequireDefault(_lodash);

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _index = require('../linear/index');

var _index2 = _interopRequireDefault(_index);

var _nonLinear = require('./non-linear');

var _nonLinear2 = _interopRequireDefault(_nonLinear);

var _companion = require('./companion');

var _companion2 = _interopRequireDefault(_companion);

var _styles = require('../helpers/styles');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var InLine = function (_React$Component) {
  _inherits(InLine, _React$Component);

  function InLine(props) {
    _classCallCheck(this, InLine);

    var _this = _possibleConstructorReturn(this, (InLine.__proto__ || Object.getPrototypeOf(InLine)).call(this, props));

    var creatives = _this.props.inLine.creatives.creative;
    var linearAd = _lodash2.default.find(creatives, function (creative) {
      return !!creative.linear;
    });
    var nonLinearAds = void 0;
    var nonLinear = _lodash2.default.find(creatives, function (creative) {
      return !!creative.nonLinearAds;
    });
    if (nonLinear) {
      nonLinearAds = nonLinear.nonLinearAds;
    }
    var companionAds = _lodash2.default.find(creatives, function (creative) {
      return !!creative.companionAds;
    });
    var videoOptions = _lodash2.default.merge({}, _this.props.videoOptions);
    if (companionAds) {
      companionAds = companionAds.companionAds;
    }
    _this.state = {
      linearAd: linearAd,
      nonLinearAds: nonLinearAds,
      videoOptions: videoOptions,
      companionAds: companionAds
    };
    return _this;
  }

  _createClass(InLine, [{
    key: 'onEnded',
    value: function onEnded() {
      this.props.onEnded();
    }
  }, {
    key: 'startVideo',
    value: function startVideo() {
      if (this.vastVideoRef) {
        this.vastVideoRef.startVideo();
      }
    }
  }, {
    key: 'render',
    value: function render() {
      var _this2 = this;

      var linearOrNonLinear = void 0;
      if (this.state.linearAd && this.state.linearAd.linear) {
        var linear = this.state.linearAd.linear;
        linearOrNonLinear = _react2.default.createElement(_index2.default, {
          ref: function ref(_ref) {
            return _this2.vastVideoRef = _ref;
          },
          onVideoEnded: function onVideoEnded(e) {
            _this2.onEnded(e);
          },
          height: this.props.height,
          width: this.props.width,
          duration: linear.duration.getValue(),
          tracking: linear.trackingEvents ? linear.trackingEvents.tracking : [],
          videoClicks: linear.videoClicks,
          mediaFiles: linear.mediaFiles.mediaFile,
          disableControls: this.state.videoOptions.disableControls
        });
      } else if (this.state.nonLinearAds && this.state.nonLinearAds.nonLinear) {
        var nonLinears = this.state.nonLinearAds.nonLinear;
        linearOrNonLinear = nonLinears.map(function (nonLinear, key) {
          var duration = 0;
          var tracking = [];
          var onEnded = function onEnded() {};
          if (key === 0) {
            duration = _this2.state.nonLinearAds.duration ? _this2.state.nonLinearAds.duration.getValue() : undefined;
            tracking = _this2.state.nonLinearAds.trackingEvents ? _this2.state.nonLinearAds.trackingEvents.tracking : [];
            onEnded = function onEnded(e) {
              _this2.onEnded(e);
            };
          }
          return _react2.default.createElement(_nonLinear2.default, {
            key: 'linear-ad-' + key,
            nonLinear: nonLinear,
            onEnded: onEnded,
            duration: duration,
            height: _this2.props.height,
            tracking: tracking,
            width: _this2.props.width
          });
        });
      }
      var companions = null;
      if (this.state.companionAds) {
        companions = this.state.companionAds.companion.map(function (companion, idx) {
          var duration = _this2.state.companionAds.duration ? _this2.state.companionAds.duration.getValue() : undefined;
          return _react2.default.createElement(_companion2.default, {
            key: 'companion-' + idx,
            duration: duration,
            tracking: companion.trackingEvents ? companion.trackingEvents.tracking : [],
            companion: companion
          });
        });
      }

      return _react2.default.createElement(
        'div',
        { style: _styles.vastBaseStyle },
        linearOrNonLinear,
        companions
      );
    }
  }]);

  return InLine;
}(_react2.default.Component);

InLine.propTypes = {
  height: _react2.default.PropTypes.number.isRequired,
  width: _react2.default.PropTypes.number.isRequired,
  inLine: _react2.default.PropTypes.object.isRequired,
  onEnded: _react2.default.PropTypes.func.isRequired,
  videoOptions: _react2.default.PropTypes.object
};

exports.default = InLine;
//# sourceMappingURL=index.js.map


// WEBPACK FOOTER //
// ./src/in-line/index.js